import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIncognito = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.5 8h-15a.5.5 0 0 1 0-1H3l1.998-4.997C5.33 1.334 5.998 1 7 1 7.668 1 8.334 1.334 9 2.003V5 2.003C9.666 1.334 10.333 1 11 1c1.003 0 1.67.334 2.003 1.003L15 7h1.5a.5.5 0 1 1 0 1zM8 12v1.233c0 .47 0 1.164-2.5 1.164S3 13.704 3 13.233V11.5a.5.5 0 0 0-.5-.5.5.5 0 1 1 0-1h.56a1 1 0 0 0 .49-.128c.439-.247 1.089-.37 1.95-.37.862 0 1.511.123 1.95.37a1 1 0 0 0 .49.128h2.12a1 1 0 0 0 .49-.129c.438-.246 1.088-.369 1.95-.369.862 0 1.512.123 1.95.37a1 1 0 0 0 .49.128h.56a.5.5 0 1 1 0 1 .5.5 0 0 0-.5.5v1.733c0 .47 0 1.164-2.5 1.164s-2.5-.693-2.5-1.164V12a1 1 0 1 0-2 0z" })
});
export default SvgIncognito;
